export const CallUpdatedTypes = {
  CALL_UPDATED: 'call_updated',
  SUGGESTED_ACTIONS_UPDATED: 'suggested_actions_updated',
} as const;

export type CallUpdatedType =
  (typeof CallUpdatedTypes)[keyof typeof CallUpdatedTypes];
